import * as types from '../constants/ActionTypes';
import api from '../../config/api.js';

export function fetchSessions(patientRecordId, parentId, from = 0) {
	return (dispatch) => {
		console.log('Getting sessions')
		return api.get(`/patients/sessions/parent/${parentId}/${patientRecordId}/${from}`)
		.then(d => {
			if(d.data){
				// if(from && from !== ""){
				// 	dispatch({
				// 	 type: types.INSERT_SESSIONS,
				// 	 payload: d.data
				//  })
				// }else{
					// dispatch({
					// 	type: types.SET_SESSIONS,
					// 	payload: d.data
					// })
				// }
				dispatch({
					type: types.SET_SESSIONS,
					payload: d.data
				})

			 	return Promise.resolve(d.data)
		 	}
			console.log('No Session Data');
			return Promise.resolve([]);
		})
		.catch(e => {
			console.log('Error getting patient sessions from server', e)
			return Promise.reject()
		})
	}
}

export function fetchParentPatientRecord(recordId, parentId) {
	return (dispatch) => {
		console.log('getting parent patients')
		return api.get(`/patients/records/parent/${parentId}/${recordId}`)
		.then(d => {
			if(d.data){
				dispatch({
				 type: types.INSERT_PATIENT_RECORD,
				 payload: d.data
			 })
			 	return d.data
		 	}else{
			 throw new Error('No data');
		 	}
		})
		.catch(e => {
			console.log('Error getting patient for parent from server', e)
			return e
		})
	}
}

export function toggleVideoDone(sessionId, videoId){
	return (dispatch) => {
		dispatch({
			type: types.TOGGLE_SESSION_VIDEO_DONE,
			payload: {
				sessionId: sessionId,
				videoId: videoId
			}
		})
	}
}

export function toggleVideoDoneAndSave(sessionId, videoId){

	return (dispatch) => {
		dispatch(toggleVideoDone(sessionId, videoId))
		return api.get(`/patients/toggle_video_done/${sessionId}/${videoId}`)
			.then( d => {
				if(d === 'ok'){
					return d;
				}else{
					// failed, undo
					toggleVideoDone(sessionId, videoId)
					return false
				}
			})
	}
}

export function fetchPatientAssessment(parentId,recordId){
	return (dispatch) => {
		return api.get(`/patients/assessment/parent/${parentId}/record/${recordId}`)
			.then(d => {
				if(d.data._id){
					dispatch({
						type: types.SET_ASSESSMENTS,
						payload: [d.data]
					})
				}
				return d.data
			})
			.catch(e => {
				console.log('Error getting patient assessments from server', e)
				return e
			})
	}
}

export function fetchAllPatientRecord(patientId) {
	return (dispatch) => {
		return api.get(`/patients/${patientId}/records`)
			.then(d => {
				// console.log(d.data[0]);
				let patientRecord = {
					'patient': patientId,
					'therapist': null,
					'practice': null
				}

				if (d.data.length) {
					patientRecord = d.data[0]
					dispatch({
						type: types.SET_PATIENT_RECORD,
						payload: patientRecord
					})
				}
				return Promise.resolve(patientRecord)
			})
			.catch(e => {
				console.log('Error getting patient record from server', e)
				return Promise.reject(e)
			})
	}
}

//Specifically for Practice owner
export function fetchAllPatientRecords(patientId) {
	return (dispatch) => {
		return api.get(`/patients/${patientId}/records`)
			.then(d => {
				// console.log(d.data[0]);
				let patientRecord = {
					'patient': patientId,
					'therapist': null,
					'practice': null
				}

				if (d.data.length) {
					patientRecord = d.data
					dispatch({
						type: types.SET_PATIENT_RECORD,
						payload: patientRecord
					})
				}
				return Promise.resolve(patientRecord)
			})
			.catch(e => {
				console.log('Error getting patient record from server', e)
				return Promise.reject(e)
			})
	}
}

export function fetchPatientAssessments(patientId, recordId) {
	return async (dispatch) => {
		console.log('Fetch Assessments');
		return await api.get(`/patients/${patientId}/records/${recordId}/assessments`)
			.then(d => {
				if (d.data.length) {
					dispatch({
						type: types.SET_ASSESSMENTS,
						payload: d.data
					})
				}
				return Promise.resolve(d.data)
			})
			.catch(e => {
				console.log('Error getting patient assessments from server', e)
				return Promise.reject(e)
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/patient.js